import type { v2, ControlTypeFunction } from '@sap/ux-specification-types';
import { ControlType } from '@sap/ux-specification-types';
import { syncRule, buildControlIdFromParent } from '../../../common/decoration';
import { addPatternForBindingChangeOfEnumOP, convertActionKeyToStableId } from '../../../common';
import type { ButtonType } from 'sap/m/library';
import type { URI } from 'sap/ui/core/library';

/**
 * Create stable ID for Object Page Header Action button.
 *
 * @param baseId Base Id of the control
 * @param idBreadcrumbs Array of breadcrumb IDs used to build the control ID
 * @param breadcrumbs Array of breadcrumb strings representing the navigation path
 * @param controlType Function to determine the control type
 * @returns stable ID of Object Page Header Action button
 */
const getActionButtonId = (
    baseId: string,
    idBreadcrumbs: string[],
    breadcrumbs: string[],
    controlType: ControlTypeFunction
): string => {
    if (controlType() === ControlType.Button || controlType() === ControlType.HeaderAction) {
        const actionId = breadcrumbs[2];
        return `${baseId}action::${convertActionKeyToStableId(actionId)}`;
    }
    return buildControlIdFromParent(baseId, idBreadcrumbs);
};

const flexRuleForHeaderAction = {
    controlId: getActionButtonId,
    controlType: (): ControlType => ControlType.HeaderAction
};

export class ObjectPageHeaderAction implements v2.ObjectPageHeaderAction {
    @syncRule({
        flex: flexRuleForHeaderAction,
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible: boolean;

    @syncRule({
        flex: flexRuleForHeaderAction
    })
    tooltip?: string;

    @syncRule({
        flex: flexRuleForHeaderAction
    })
    icon?: URI;

    @syncRule({
        flex: flexRuleForHeaderAction
    })
    activeIcon?: URI;

    @syncRule({
        flex: flexRuleForHeaderAction
    })
    type?: ButtonType;
}
